import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getAvailableCreditsTotal } from "app/pages/Account/MyCoupons/couponSelector";
import TotalCreditBanner from "app/pages/FicheProduit/components/Credit/TotalCreditBanner";

const TotalCreditBannerContainer = ({ totalCredit }) => (
	<TotalCreditBanner totalCredit={totalCredit} />
);

TotalCreditBannerContainer.propTypes = {
	totalCredit: PropTypes.any,
};

const mapStateToProps = state => ({
	totalCredit: getAvailableCreditsTotal(state),
});

export default connect(mapStateToProps)(TotalCreditBannerContainer);
